import './js/init';
import './main.d.scss';
